import store from '../../redux-store/store';

export interface CustomFrontendApp {
  appId: string;
  url: string;
}

export type CustomFrontendMenuTarget = 'inApp' | 'newTab';

export interface CustomFrontendMenuEntry {
  id: string;
  appId: string;
  label: string;
  icon?: string;
  parent: string[];
  target: CustomFrontendMenuTarget;
  iframeRoute: string;
  permissions?: string[];
}

export interface CustomFrontendSlot {
  id: string;
  appId: string;
  iframeRoute: string;
  permissions?: string[];
  presentation?: 'inline' | 'overlay';
}

interface CustomFrontendManifest {
  apps: CustomFrontendApp[];
  menu: CustomFrontendMenuEntry[];
  slots: CustomFrontendSlot[];
}

function readManifest(): CustomFrontendManifest | undefined {
  return store.getState()?.masterData?.custom_frontend_manifest;
}

export function getCustomFrontendApps(): CustomFrontendApp[] {
  return readManifest()?.apps ?? [];
}

export function getCustomFrontendMenu(): CustomFrontendMenuEntry[] {
  return readManifest()?.menu ?? [];
}

export function findCustomFrontendApp(appId: string): CustomFrontendApp | undefined {
  return getCustomFrontendApps().find((a) => a.appId === appId);
}

export function findCustomFrontendMenuById(id: string): CustomFrontendMenuEntry | undefined {
  return getCustomFrontendMenu().find((m) => m.id === id);
}

export function findCustomFrontendSlot(id: string): CustomFrontendSlot | undefined {
  return readManifest()?.slots?.find((s) => s.id === id);
}
